// extracted by mini-css-extract-plugin
export default {"registration":"registration_registration__m6Jum","title":"registration_title__FkeOk","content":"registration_content__OtKMT","logo":"registration_logo__XUEiJ"};